import React, { useState } from 'react';
import { connect } from 'redux-scaffolding-ts';
import { StudentsTabViewModel } from 'site/pages/shared/events-and-requests/tabs/students-assign-component';
import TailwindStudentsAssignTableComponent from 'site/pages/shared/events-and-requests/tabs/students-assign-component-tw';
import { RequestFormStore, RequestFormViewModel } from 'stores/requests/request-form-store';

interface RequestStudentContainerProp {
  request?: RequestFormViewModel;
  readOnly: boolean;
  requestFormStore?: RequestFormStore;
  onChange?: (value: Partial<RequestFormViewModel>) => void;
}

const RequestStudentContainer: React.FC<RequestStudentContainerProp> = ({ request, readOnly, requestFormStore, onChange }) => {
  const [selectedRequest, setSelectedRequest] = useState<RequestFormViewModel>(request);

  const handleOnStudentsChange = (newValue: StudentsTabViewModel) => {
    const requestcopy = { ...selectedRequest };
    setSelectedRequest({ ...requestcopy, ...newValue });
    requestFormStore.change({
      students: newValue.students,
      studentsNumber: newValue.studentsAssigned
    });
    onChange && onChange({ students: newValue.students, studentsNumber: newValue.studentsAssigned });
  };

  const value: StudentsTabViewModel = {
    students: selectedRequest.students,
    studentsAssigned: selectedRequest.studentsNumber
  };

  return <TailwindStudentsAssignTableComponent cameFrom="Request" readOnly={readOnly} value={value} onChange={handleOnStudentsChange} />;
};

export default connect(['requestFormStore', RequestFormStore])(RequestStudentContainer);
